import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled, { default as _styled2 } from "styled-components";
var _Navbar, _QuestionMarkCircle, _Search, _templateObject;
import { Fragment } from "react";
import cn from "classnames";
import { css } from "styled-components";
import QuestionMarkCircle from "@crehana/icons/outline/QuestionMarkCircle";
import { Container } from "@crehana/ui";
import NightSwitch from "../../components/NightSwitch";
import LeftMenu from "../../MainMenu/components/LeftMenu";
import Logo from "../../MainMenu/components/Logo";
import UserMenu from "../../MainMenu/components/UserMenu";
import { useMainMenuContext, useMainMenuTranslation } from "../../MainMenu/hooks";
import Navbar from "../../MainMenu/ui/Navbar";
import RightMenu from "../components/RightMenu";
import Search from "../components/Search";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DashboardMenuMobile = function DashboardMenuMobile(_ref) {
  var shouldRenderSearch = _ref.shouldRenderSearch;
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  var _useMainMenuContext = useMainMenuContext(),
    theme = _useMainMenuContext.theme,
    isTransparent = _useMainMenuContext.isTransparent,
    layoutConfig = _useMainMenuContext.layoutConfig,
    userTheme = _useMainMenuContext.userTheme,
    onToggleUserTheme = _useMainMenuContext.onToggleUserTheme,
    onMobileFAQsClick = _useMainMenuContext.onMobileFAQsClick,
    dashboardTitle = _useMainMenuContext.dashboardTitle;
  var shouldRenderNightSwitch = onToggleUserTheme && !layoutConfig.hideNightSwitch;
  var shouldRenderFAQsButton = onMobileFAQsClick;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [_Navbar || (_Navbar = /*#__PURE__*/_jsx(Navbar, {
      children: /*#__PURE__*/_jsxs(Container, {
        type: "dashboard",
        className: "flex justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center lg:flex-row-reverse",
          children: [/*#__PURE__*/_jsx(LeftMenu, {}), /*#__PURE__*/_jsx(Logo, {})]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center",
          children: [/*#__PURE__*/_jsx(RightMenu, {}), /*#__PURE__*/_jsx(UserMenu, {})]
        })]
      })
    })), (shouldRenderNightSwitch || shouldRenderFAQsButton) && /*#__PURE__*/_jsx(_StyledDiv, {
      className: cn('w-full flex justify-center border-solid border-t', theme.nav.textColorClassName, theme.nav.dividerColorClassName, _defineProperty({}, theme.nav.backgroundColorClassName, !isTransparent)),
      $_css: theme.nav.zIndex,
      $_css2: theme.nav.height.xs,
      children: /*#__PURE__*/_jsxs(Container, {
        type: "dashboard",
        className: cn('flex items-center h-48', shouldRenderNightSwitch && shouldRenderFAQsButton ? 'justify-between' : 'justify-end'),
        children: [shouldRenderNightSwitch && /*#__PURE__*/_jsx(NightSwitch, {
          isDark: userTheme === 'dark',
          toggleTheme: onToggleUserTheme
        }), onMobileFAQsClick && /*#__PURE__*/_jsxs("button", {
          type: "button",
          className: "flex items-center font-label text-base-lighter",
          onClick: onMobileFAQsClick,
          children: [_QuestionMarkCircle || (_QuestionMarkCircle = /*#__PURE__*/_jsx(QuestionMarkCircle, {
            size: 24,
            ignoreColor: true,
            className: "mr-8 fill-current"
          })), t('FAQS')]
        })]
      })
    }), (dashboardTitle || shouldRenderSearch) && /*#__PURE__*/_jsx(_StyledDiv2, {
      className: cn('w-full flex justify-center border-solid border-t', theme.nav.textColorClassName, theme.nav.dividerColorClassName, theme.nav.dashboardPaddingClassNames, _defineProperty({}, theme.nav.backgroundColorClassName, !isTransparent)),
      $_css3: theme.nav.zIndex,
      children: /*#__PURE__*/_jsxs(Container, {
        type: "dashboard",
        className: cn('flex items-center justify-between h-48', dashboardTitle && shouldRenderSearch ? 'justify-between' : {
          'justify-end': shouldRenderSearch
        }),
        children: [dashboardTitle && /*#__PURE__*/_jsx("h1", {
          className: "font-h2",
          children: dashboardTitle
        }), shouldRenderSearch && (_Search || (_Search = /*#__PURE__*/_jsx(Search, {})))]
      })
    })]
  });
};
export default DashboardMenuMobile;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n            transition: ", ";\n            z-index: ", ";\n            height: ", "px;\n          "])), function (props) {
  return props.theme.transition(['background-color', 'color']);
}, function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  componentId: "sc-mih027-0"
})(["\n            transition: ", ";\n            z-index: ", ";\n          "], function (props) {
  return props.theme.transition(['background-color', 'color']);
}, function (p) {
  return p.$_css3;
});